import http from './_http'

const setting = {
  add: (m) => http.post(`api/v3/setting`, m),
  get: (id) => http.get(`api/v3/setting/${id}`),
  list: (m) => http.post(`api/v3/setting/search`, m),
  update: (m) => http.put(`api/v3/setting`, m),
  delete: (id) => http.delete(`api/v3/setting/${id}`),
}
export default setting